import { Component } from '@angular/core';

import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MaskitoDirective } from '@maskito/angular';
import { FormlyModule } from '@ngx-formly/core';
import { InputFieldType } from '../input-field-type';

@Component({
    selector: 'app-input',
    templateUrl: './input.component.html',
    imports: [ReactiveFormsModule, FormlyModule, MaskitoDirective]
})
export class InputComponent extends InputFieldType {
  get type() {
    return this.props.type || 'text';
  }

  get inputFormControl(): FormControl {
    return this.formControl as FormControl;
  }
}
